import { Component } from '@angular/core';

import { AppBugreportingComponent } from '../app-bugreporting/app-bugreporting.component'

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.css']
})
export class AppFooterComponent { }



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-footer/app-footer.component.ts